module.exports = __webpack_public_path__ + "images/emoji/frog.a6426d469859662e0e13.png";